// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3i_9I","question":"Question_question__AVR9X","description":"Question_description__3t0nQ"};